import { render } from "./nanamota-shop-grid.vue?vue&type=template&id=8667dcae&scoped=true"
import script from "./nanamota-shop-grid.vue?vue&type=script&lang=js"
export * from "./nanamota-shop-grid.vue?vue&type=script&lang=js"

import "./nanamota-shop-grid.vue?vue&type=style&index=0&id=8667dcae&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8667dcae"]])

export default __exports__